export const InvestorType = {
	Retail: 'Retail',
	Professional: 'Professional',
	Corporate: 'Corporate',
	CorporateRetail: 'CorporateRetail',
};

export const InvestorTypeId = {
	Retail: 1,
	Professional: 2,
	Corporate: 3,
	CorporateRetail: 4,
};

export const isCorporateType = (name) =>
	name === InvestorType.Corporate || name === InvestorType.CorporateRetail;

export const isCorporateTypeId = (id) =>
	id === InvestorTypeId.Corporate || id === InvestorTypeId.CorporateRetail;
